/* eslint-disable camelcase */
export const APP_TOKEN = '__TOKEN__';
export const CID = '__CID__';
export const CIDP = '__CIDP__';
export const UID = '__UID__';
export const UIDP = '__UIDP__';
export const EXP = '__EXP__';
export const CIDX = '__CIDX__';
export const IS_SHOW_SURVEY = '__SHOW_SURVEY__';
export const PATH_NAME = '__FIRST_PATH_NAME__';
export const CURRENT_USER = '__CURRENT_USER__';
export const CURRENT_USER_NUXT = 'userData';
export const EMBED_QUICKSIGHT = 'quicksight';
export const EMBED_METABASE = 'metabase';

export const MONTH_NAME = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MONTH_SHORT_NAME = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const LABEL_HEADCOUNT_SERVICE_LENGTH = {
  less_1_year: '<1y',
  more_1_year: '1y',
  more_2_year: '2y',
  more_3_year: '3y',
  more_4_year: '4y',
  more_5_year: '>=5y',
};

export const LABEL_ATTENDANCE_ARR = ['Absent', 'Late', 'On Time', 'Time off'];

export const LABEL_ATTENDANCE_OBJ = {
  absence_percentage: 'Absent',
  late_percentage: 'Late',
  ontime_percentage: 'On Time',
  timeoff_percentage: 'Time off',
};

export const columnsAttendanceLateIn = [
  {
    Header: 'Employee Name',
    accessor: 'full_name',
  },
  {
    Header: 'Employee ID',
    accessor: 'id_employee',
  },
  {
    Header: 'Job Position',
    accessor: 'job_position',
  },
  {
    Header: 'Shift',
    accessor: 'shift',
  },
  {
    Header: 'Late in (minutes)',
    accessor: 'late_in',
  },
];

export const columnsAttendanceOnTime = [
  {
    Header: 'Employee Name',
    accessor: 'full_name',
  },
  {
    Header: 'Employee ID',
    accessor: 'id_employee',
  },
  {
    Header: 'Job Position',
    accessor: 'job_position',
  },
  {
    Header: 'Shift',
    accessor: 'shift',
  },
  {
    Header: 'Early (minutes)',
    accessor: 'on_time',
  },
];

export const columnsAttendanceAbsent = [
  {
    Header: 'Employee Name',
    accessor: 'full_name',
  },
  {
    Header: 'Employee ID',
    accessor: 'id_employee',
  },
  {
    Header: 'Job Position',
    accessor: 'job_position',
  },
  {
    Header: 'Shift',
    accessor: 'shift',
  },
];

export const columnsAttendanceTimeoff = [
  {
    Header: 'Employee Name',
    accessor: 'full_name',
  },
  {
    Header: 'Employee ID',
    accessor: 'id_employee',
  },
  {
    Header: 'Job Position',
    accessor: 'job_position',
  },
  {
    Header: 'Shift',
    accessor: 'shift',
  },
  {
    Header: 'Policy',
    accessor: 'policy_name',
  },
];

export const columnsAttendanceDayoff = [
  {
    Header: 'Employee Name',
    accessor: 'full_name',
  },
  {
    Header: 'Employee ID',
    accessor: 'id_employee',
  },
  {
    Header: 'Job Position',
    accessor: 'job_position',
  },
  {
    Header: 'Shift',
    accessor: 'shift',
  },
];

export const columnsAttendanceNoCheckIn = [
  {
    Header: 'Employee Name',
    accessor: 'full_name',
  },
  {
    Header: 'Employee ID',
    accessor: 'id_employee',
  },
  {
    Header: 'Job Position',
    accessor: 'job_position',
  },
  {
    Header: 'Shift',
    accessor: 'shift',
  },
];

export const POLICY_COLOR = [
  '#d74022',
  '#ffbbff',
  '#009f61',
  '#ffeb99',
  '#009bde',
  '#f96d01',
  '#6d48e5',
  '#005fbf',
  '#ffb700',
  '#1357ff',
  '#212121',
  '#C76D7E',
  '#8D918B',
  '#FFEFD3',
  '#FFC49B',
  '#294C60',
  '#17C3B2',
  '#227C9D',
  '#904E55',
  '#2C514C',
  '#E3C0D3',
  '#95818D',
  '#122932',
  '#9B287B',
  '#29E7CD',
  '#E0ACD5',
  '#6A3E37',
  '#C9A690',
  '#D36582',
  '#1B3022',
  '#A67DB8',
  '#A0EADE',
  '#4CB963',
  '#829e59',
  '#000084',
  '#00d5cf',
  '#770015',
  '#00d4ff',
  '#4e6dfb',
  '#ff9aa4',
  '#009eff',
  '#4964c1',
  '#00eba5',
  '#000b89',
  '#aeff2f',
  '#ab8a29',
  '#2dbbff',
  '#650014',
  '#009fbb',
  '#ffadc0',
  '#ffdeff',
  '#58daff',
  '#fc3100',
  '#00ffff',
  '#920021',
  '#00ffff',
  '#db80e6',
  '#5b4000',
  '#6e9cff',
  '#00796f',
  '#00373d',
  '#ff968f',
  '#00c900',
  '#00acff',
  '#3ab500',
  '#003a5b',
  '#ff956d',
  '#00b4cf',
  '#005f00',
  '#002d23',
  '#009583',
  '#c02a34',
];

export const riskLevel = [
  {
    color: '#FF7170',
    name: 'High Risk',
  },
  {
    color: '#FFBD70',
    name: 'Medium Risk',
  },
  {
    color: '#4486E6',
    name: 'Low Risk',
  },
];

export const risk_lists = [
  {
    label: 'High Risk',
    value: 'high',
    isChecked: true,
  },
  {
    label: 'Medium Risk',
    value: 'medium',
    isChecked: false,
  },
  {
    label: 'Low Risk',
    value: 'low',
    isChecked: false,
  },
];

export const DASHBOARD_HEADCOUNT = 'Headcount';
export const DASHBOARD_ATTENDANCE = 'Attendance';
export const DASHBOARD_EMPLOYEE_AT_RISK = 'Employee At Risk';
export const DASHBOARD_EMPLOYEE_TRANSFER = 'Employee Transfer';
export const NEW_INSIGHT_LINK = {
  newActive: '/v2/new-active',
  turnover: '/v2/employee-turnover',
  attendance: '/v2/attendance',
  employeeAtRisk: '/v2/employee-at-risk',
  payroll: '/v2/payroll',
  teamAttendance: '/v2/team-attendance',
  performance: '/v2/employee-performance',
  overtime: '/v2/overtime',
  reportBuilder: 'https://hr.talenta.co/report-builder/index',
};
export const REPORT_BUILDER_LINK = {
  basicReport: '/report-builder/index',
  pivotReport: '/report-builder/index#pivot',
};
export const AIRENE_URL =
  'https://hr.talenta.co/employee/dashboard#airene?topic=';
